


























import { Vue, Component, Watch } from 'vue-property-decorator';
import NotificationContent from './NotificationContent.vue';
import Loading from '@/components/Loading.vue';

import NotificationsModule from '@/store/notifications';

@Component({
    components: {
        NotificationContent,
        Loading,
    },
})
export default class AppMenuNotificationsList extends Vue {
    @Watch('notifications')
    async onNotificationsChange() {
        await this.$nextTick();
        this.updateIntersectionObserver();
    }

    @Watch('isShow')
    onIsShowChange(newVal: boolean) {
        if (newVal && this.hasUnread) {
            this.readAll();
        }
    }

    itemsWrapper: Element = this.$el;
    currentMarker: Element | null = null;
    currentMarkerHeight: number | null = null;
    isLoadNextPageBlocked = false;
    maxPagesReached = false;
    observer: IntersectionObserver | null = null;

    get isShow() {
        return NotificationsModule.isShow;
    }

    get isLoading() {
        return NotificationsModule.isLoading;
    }

    get hasUnread() {
        return this.notifications.filter(notification => !notification.readAt).length;
    }

    get notifications() {
        return NotificationsModule.notifications;
    }

    observe(entries: any) {
        const lastNotification = entries[0];

        if (this.isLoading) {
            return;
        }

        if (lastNotification.isIntersecting) {
            this.$emit('next');
        }
    }

    updateIntersectionObserver() {
        this.observer?.disconnect();

        const elements = Array.from(this.$el.getElementsByClassName('notification-content'));
        this.currentMarker = elements[elements.length - 1];

        if (this.currentMarker) {
            this.observer?.observe(this.currentMarker);
        }
    }

    initIntersectionObserver() {
        const options = { root: this.$el };
        this.observer = new IntersectionObserver(this.observe, options);
    }

    async created() {
        if (this.hasUnread) {
            this.readAll();
        }
    }

    readAll() {
        NotificationsModule.readAll();
    }

    readSingle(id: number) {
        NotificationsModule.readSingle(id);
    }
    
    mounted(): void {
        this.initIntersectionObserver();
    }
}
